import { LoaderFunction, useFetcher } from "react-router-dom";
import { getExpiredAssets } from "../../../../common/api/decimal/methods/license.ts";

export const expiredDataLoader: LoaderFunction = async ({
  params,
  request,
}) => {
  const url = new URL(request.url);
  if (params.page) {
    const opts: Parameters<typeof getExpiredAssets>[1] = {};
    const expiredAt = url.searchParams.get("expiredAt");
    const cmp = url.searchParams.get("cmp");
    if (expiredAt) {
      opts.expiredAt = {
        isoDate: expiredAt,
        cmp,
      } as (typeof opts)["expiredAt"];
    }

    return getExpiredAssets(parseInt(params.page, 10), opts);
  }
};

export function useExpiredDataFetcher() {
  return useFetcher<Awaited<ReturnType<typeof getExpiredAssets>>>();
}
